const getBaseUrl = () => {
    if (typeof window !== 'undefined') {
          if (window.location.host.includes('mydnatest24.com')) {
                  return 'https://mydnatest24.com';
          }
          if (window.location.host.includes('ethnica.app')) {
                  return 'https://ethnica.app';
          }
          return 'https://mytraits.ai';
    }
    return 'https://mytraits.ai';
};

const BASE_URL = getBaseUrl();

export const APP_URLS = {
    COOKIE: `${BASE_URL}/cookies`,
    PRIVACY: `${BASE_URL}/policy`,
    TERMS: `${BASE_URL}/terms`,
    REFUND: 'https://form.typeform.com/to/XMsW9a3d',
};

export const PROFILE_PRO_PLAN_ID = 'mydnatest24_1';
export const PROFILE_PRO_SALE_PLAN_ID = 'mydnatest24_1';
export const MATCH_REPORT_PLAN_ID = 'mydnatest24_2';
export const FUTURE_CHILD_REPORT_PLAN_ID = 'mydnatest24_4';
export const HEALTH_SCAN_REPORT_PLAN_ID = 'mydnatest24_5';
export const MATCH_REPORT_SALE_PLAN_ID = 'mydnatest24_2';
export const ULTIMATE_PACK_PLAN_ID = 'mydnatest24_3';

export const PROFILE_PRO_PLANS_IDS = [PROFILE_PRO_PLAN_ID];

export const MATCH_REPORT_PLAN_IDS = [MATCH_REPORT_PLAN_ID];

export const FUTURE_CHILD_REPORT_PLAN_IDS = [FUTURE_CHILD_REPORT_PLAN_ID];

export const HEALTH_SCAN_REPORT_PLAN_IDS = [HEALTH_SCAN_REPORT_PLAN_ID];

export const ULTIMATE_PACK_PLAN_IDS = [ULTIMATE_PACK_PLAN_ID];

// PREMIUM PURCHASE ON UNSUBSCRIBE
export const PREMIUM_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID = 'mytraits_premium_one_month';
export const PREMIUM_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_IDS = [
    PREMIUM_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID,
  ];

// GIFT ONE MONTH PURCHASE ON UNSUBSCRIBE
export const GIFT_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID = 'mytraits_gift_one_month';
export const GIFT_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_IDS = [
    GIFT_ONE_MONTH_PURCHASE_SUBSCRIPTION_PLAN_ID,
  ];

// PayPal trial plan ids
export const PAYPAL_TRIAL_PLAN_IDS = [
    'P-9F484174VH125021ANE3LS4Y', //mytraits_3d5_7d2499
    'P-7JX29414MC217192YNEW3KAQ', //mytraits_3d5_7d2499 STG
    'P-8HA19696WL408064LNFJISWY', //mytraits_3d1_7d1499
    'P-3U5840938U610380GNFJIUKI', //mytraits_3d1_7d1999
    'P-8EH69133KP932050DNFJIWJI', //mytraits_3d5_1m2999
  ];

export const PAYPAL_THREE_MONTH_PLAN_IDS = [
    'P-1V585984HW9857641NFJZ4LA', //mytraits_3m4400_3m4900
    'P-7K72741702477424RNFJZ6DY', //mytraits_3m4800_3m4900
  ];

export interface IAmountLocal {
    value: number;
    currency: string;
}

export interface IPaymentPlan {
    id: string;
    sum: number;
    sum_local?: IAmountLocal;
    length: string;
    name: string;
    name_full: string;
    trial_sum?: number;
    trial_sum_local?: IAmountLocal;
    discount_percent: number;
    prev_price?: number;
    currency?: string;
    paypalPlanId?: string;
}

export const DEFAULT_TRIAL_PLAN: IPaymentPlan = {
    id: 'mydna24_week5',
    trial_sum: 5,
    sum: 24.99,
    length: '1w',
    discount_percent: 80,
    name: 'Weekly Plan',
    name_full: 'Weekly Plan',
    prev_price: 24.99,
    currency: 'USD',
};

export const fallbackProfileProPlan = {
    id: 'mydnatest24_1',
    sum: 27,
    length: 'lifetime',
    discount_percent: 33,
    name: 'Profile PRO',
    name_full: 'Profile PRO Access',
    currency: 'USD',
};

export const fallbackMatchReportPlan = {
    id: 'mydnatest24_2',
    sum: 47,
    length: 'lifetime',
    discount_percent: 45,
    name: 'Report',
    name_full: 'Full Report Access',
    currency: 'USD',
};

export const fallbackFutureChildReportPlan = {
    id: 'mydnatest24_4',
    sum: 47,
    length: 'lifetime',
    discount_percent: 33,
    name: 'Child Report',
    name_full: 'Child Profile Report',
    currency: 'USD',
};

export const fallbackHealthScanReportPlan = {
    id: 'mydnatest24_5',
    length: '120m',
    sum: 57,
    name: 'Health Scan Report',
    name_full: 'Health Scan Report',
    discount_percent: 45,
    currency: 'USD',
};
